import { QueryLazyOptions } from "@apollo/client";
import { useUser } from "@saleor/auth";
import Autocomplete from "@saleor/components/AutocompleteForObject";
import {
  DistributionChannelType,
  Exact,
  ExportShipToFilterInput,
  ExportSoldToFilterInput
} from "@saleor/graphql";
import React, { useEffect, useState } from "react";

interface IProps {
  handleSelectedSearch?: (value: any) => void;
  inputValue?: string;
  setInputValue?: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  first?: number;
  isClean?: boolean;
  contained: boolean;
  name?: string;
  getDataSuggestions: (
    options?: QueryLazyOptions<
      Exact<{
        filter?: ExportShipToFilterInput | ExportSoldToFilterInput;
        first?: number;
        distributionChannelType?: DistributionChannelType;
        bu?: string;
      }>
    >
  ) => void;
  fetchDataSuggestions?: any;
  loadingDataSuggestion: boolean;
  dataOptions: any[];
  error?: boolean;
  searchField: string;
  objectSuggestion?: boolean;
  isCheckingRole?: boolean;
  id?: string;
  testId?: string;
}

const InputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    handleSelectedSearch,
    placeholder,
    first,
    isClean,
    contained,
    getDataSuggestions,
    loadingDataSuggestion,
    dataOptions,
    error,
    searchField,
    objectSuggestion,
    isCheckingRole,
    id,
    name,
    testId
  } = props;

  const { zone } = useUser();

  const [value, setValue] = useState<string>("");

  const handleChange = event => {
    setValue(event);
  };

  useEffect(() => {
    if (value?.length >= 2) {
      const filterObj = { [searchField]: value };
      getDataSuggestions({
        variables: {
          first: first || 100,
          filter: filterObj,
          distributionChannelType: isCheckingRole
            ? (zone?.toUpperCase() as DistributionChannelType)
            : undefined,
          bu: "PP"
        }
      });
    }
  }, [value]);

  return (
    <div>
      <Autocomplete
        contained={contained}
        optionsProp={dataOptions}
        placeholderProps={placeholder}
        onChangeProps={handleChange}
        loading={loadingDataSuggestion}
        onSearch={handleSelectedSearch}
        objectSuggestion={objectSuggestion}
        isReset={isClean}
        error={error}
        resetAlways
        id={id}
        name={name}
        testId={testId}
      />
    </div>
  );
};

export default InputSuggestion;
